import { useEffect } from "react";
import { acquireScrollLock } from "../utils/scrollLock";

export function useScrollLock(active: boolean) {
  useEffect(() => (active ? acquireScrollLock() : undefined), [active]);
}
